// extracted by mini-css-extract-plugin
export default {"card":"NY-z","carouselContainer":"OY-z","carouselContent":"PY-z"};